<template>
  <Doughnut
    :chart-options="chartOptions"
    :chart-data="chartData"
    :chart-id="chartId"
    :dataset-id-key="datasetIdKey"
    :plugins="plugins"
    :css-classes="cssClasses"
    :styles="styles"
    :width="width"
    :height="height"
  />
</template>

<script>
import { Doughnut } from 'vue-chartjs/legacy';

import { Chart as ChartJS, registerables } from 'chart.js';

ChartJS.register(...registerables);

export default {
  name: 'DoughnutChart',
  components: {
    Doughnut,
  },
  props: {
    chartId: {
      type: String,
      default: 'doughnut-chart',
    },
    datasetIdKey: {
      type: String,
      default: 'label',
    },
    width: {
      type: Number,
      default: 400,
    },
    height: {
      type: Number,
      default: 400,
    },
    cssClasses: {
      default: '',
      type: String,
    },
    styles: {
      type: Object,
      default: () => {},
    },
    plugins: {
      type: Array,
      default: () => {
        return [];
      },
    },
    chartOptions: {
      type: Object,
      default: () => {},
    },
    chartData: {
      type: Object,
      default: () => {},
    },
  },
  // data() {
  //   return {
  //     chartData: {
  //       labels: ['VueJs', 'ReactJs'],
  //       datasets: [
  //         {
  //           backgroundColor: ['#41B883', '#E46651'],
  //           data: [40, 20],
  //         },
  //       ],
  //     },
  //     chartOptions: {
  //       responsive: true,
  //       maintainAspectRatio: false,
  //     },
  //   };
  // },
};
</script>
